var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col left" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sidebar.posbranchmanagement")) +
                  " > " +
                  _vm._s(_vm.$t("sidebar.create")) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-8 right" }, [
            _vm.ready
              ? _c("div", { staticClass: "action" }, [
                  _vm.hasRoleDelete
                    ? _c("div", { staticClass: "dropdown item" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn no-bg dropdown-toggle text-secondary shake",
                            attrs: {
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-haspopup": "true",
                              "aria-expanded": "false"
                            }
                          },
                          [
                            _c("i", { staticClass: "fas fa-cog" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "name" }, [
                              _vm._v(_vm._s(_vm.$t("button.options")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "dropdown-menu dropdown-menu-right" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: { click: _vm.onOpenModal }
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-trash text-danger"
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.$t("button.delete")))
                                ])
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : [
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.general") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-md-6" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.posbranchname")) + " *"
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.$v.form.name.$model,
                                    expression: "$v.form.name.$model"
                                  }
                                ],
                                class: [
                                  "form-control",
                                  { "is-invalid": _vm.$v.form.name.$error }
                                ],
                                attrs: { disabled: !_vm.hasRoleEdit },
                                domProps: { value: _vm.$v.form.name.$model },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.$v.form.name,
                                      "$model",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-6" }, [
                              _c(
                                "label",
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("message.posbranchnameshort")
                                      ) +
                                      " *\n                    "
                                  ),
                                  _c(
                                    "vs-tooltip",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        "margin-left": "5px"
                                      },
                                      attrs: {
                                        text: _vm.$t(
                                          "message.runningcodenumber"
                                        ),
                                        position: "top"
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-info-circle"
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.$v.form.nameShort.$model,
                                    expression: "$v.form.nameShort.$model"
                                  }
                                ],
                                class: [
                                  "form-control text-uppercase",
                                  { "is-invalid": _vm.$v.form.nameShort.$error }
                                ],
                                attrs: {
                                  placeholder: _vm.$t(
                                    "placeholder.maximumlength6char"
                                  ),
                                  maxlength: 6,
                                  disabled: !_vm.hasRoleEdit
                                },
                                domProps: {
                                  value: _vm.$v.form.nameShort.$model
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.$v.form.nameShort,
                                      "$model",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _vm.nameShortUppercase
                              ? _c("div", { staticClass: "col-6 pl-0" }, [
                                  _c("label", [_vm._v(" ")]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "preview-short-name" },
                                    [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("message.previewpscode", {
                                              name: _vm.nameShortUppercase,
                                              code:
                                                _vm
                                                  .moment()
                                                  .format("YYYY/MM/DD") + "/01"
                                            })
                                          )
                                        }
                                      })
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.location") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-6" },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.address")))
                                ]),
                                _vm._v(" "),
                                _c("b-form-textarea", {
                                  staticStyle: { "min-height": "70px" },
                                  attrs: { disabled: !_vm.hasRoleEdit },
                                  model: {
                                    value: _vm.form.address,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "address", $$v)
                                    },
                                    expression: "form.address"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.config") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-md-6" }, [
                              _c(
                                "label",
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.posbranchcountingstrock"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                  _c(
                                    "vs-tooltip",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        "margin-left": "5px"
                                      },
                                      attrs: {
                                        text: _vm.$t(
                                          "message.cutstockfromselectedwarehouse"
                                        ),
                                        position: "top"
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-info-circle"
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.whId,
                                      expression: "form.whId"
                                    }
                                  ],
                                  staticClass: "form-control custom-select",
                                  attrs: { disabled: !_vm.hasRoleEdit },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.form,
                                        "whId",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { domProps: { value: null } }, [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.$t("placeholder.select")) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.form.whItems, function(
                                    item,
                                    index
                                  ) {
                                    return _c(
                                      "option",
                                      {
                                        key: index,
                                        attrs: { index: index },
                                        domProps: { value: item.value }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(item.text) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ])
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.assignproducts") }
                      }),
                      _vm._v(" "),
                      !_vm.products.length
                        ? _c("BaseNotFoundData", {
                            attrs: {
                              title: _vm.$t("apps.pos.message.notfoundproduct"),
                              detail: _vm.$t("apps.pos.message.createproduct")
                            }
                          })
                        : _c("base-assign-items", {
                            attrs: {
                              items: _vm.form.assignProductItems,
                              disabled: !_vm.hasRoleEdit
                            },
                            model: {
                              value: _vm.form.assignProductIds,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "assignProductIds", $$v)
                              },
                              expression: "form.assignProductIds"
                            }
                          })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.favoriteproducts") }
                      }),
                      _vm._v(" "),
                      _c("base-assign-items", {
                        attrs: {
                          items: _vm.form.favoriteProductItems,
                          disabled: !_vm.hasRoleEdit
                        },
                        model: {
                          value: _vm.form.favoriteProductIds,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "favoriteProductIds", $$v)
                          },
                          expression: "form.favoriteProductIds"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.hasRoleEdit
                  ? _c("section", { staticClass: "action-bar" }, [
                      !_vm.isSubmitted
                        ? _c("div", { staticClass: "col-md-12 text-right" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-web",
                                on: { click: _vm.onSave }
                              },
                              [_vm._v(_vm._s(_vm.$t("button.save")))]
                            )
                          ])
                        : _c("div", { staticClass: "col-md-12 text-right" }, [
                            _vm._m(0)
                          ])
                    ])
                  : _vm._e()
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c("base-confirm-delete-modal", {
        attrs: { show: _vm.showConfirmDeleteModal, loading: _vm.loadingModal },
        on: {
          onClose: _vm.handleCloseModal,
          onCancel: _vm.handleCancleModal,
          onSubmit: _vm.handleSumitModal
        }
      }),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3519462f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3519462f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/branch/Edit.vue
// module id = null
// module chunks = 